import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiEventManager} from 'ng-jhipster';
import {IActivityChild} from '@entities/activity/activity.model';
import {ActivityService} from '@entities/activity/activity.service';

@Component({
  selector: 'app-activity-child-delete-dialog',
  templateUrl: './activity-type-delete-child-dialog.component.html',
})
export class ActivityDeleteChildDialogComponent {
  activityChild: IActivityChild;

  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }

  constructor(
    private dialogRef: MatDialogRef<ActivityDeleteChildDialogComponent>,
    private activityTypeService: ActivityService,
    private eventManager: JhiEventManager,
  ) {}

  confirmDelete(activityTypeId) {
    this.activityTypeService
      .deleteActivityChild(activityTypeId)
      .subscribe((response) => {
        this.eventManager.broadcast({
          name: 'activityChildListModification',
          content: 'Deleted a hoạt động',
        });
        this.dialogRef.close(true);
      });
  }
}

@Component({
  selector: 'app-activity-child-delete-popup',
  template: '',
})
export class ActivityDeleteChildPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<ActivityDeleteChildDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityTypeChild.delete'),
    );
    this.activatedRoute.data.subscribe(({activityChild}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(ActivityDeleteChildDialogComponent, {
          disableClose: true,
          width: '380px',
        });

        this.dialogRef.componentInstance.activityChild = activityChild;

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityType.detail'),
    );
    this.dialogRef = null;
  }
}
